import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 126.3 164.1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M110.7 52.2c-5.1-8.5-10.8-15.5-17-20.8l5.6-13.2c4.4 1.2 9.2-.9 11-5.3 2-4.7-.2-10.2-4.9-12.2S95.2.9 93.2 5.6c-1.9 4.3-.1 9.3 3.8 11.6l-5.4 12.5C82.8 22.8 73.2 19 63.2 19c-9.6 0-18.8 3.5-27.3 9.9l-5-11.6c3.9-2.4 5.7-7.3 3.8-11.6-2-4.7-7.5-6.9-12.2-4.9S15.6 8.3 17.6 13c1.9 4.3 6.6 6.5 11 5.3l5.2 12.2C27.2 35.9 21 43.2 15.7 52.2 6 68.5 0 88.5 0 104.3c0 20.6 10.2 30.4 18.8 34.9 9.7 5.2 21.3 5.6 31.3 5.6H75l25.3 16.3v-19c2.4-.7 4.8-1.7 7.1-2.9 8.6-4.6 18.8-14.3 18.8-34.9.1-15.8-5.9-35.8-15.5-52.1m-34.5 74c-4.1 0-8.5-.1-13-.1s-8.9.1-13 .1c-18.3 0-31.5-1.9-31.5-21.9 0-24.6 20-66.7 44.6-66.7s44.6 42.1 44.6 66.7c-.2 20.1-13.5 21.9-31.7 21.9",
  style: {"fill":"#008ac5"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M63.7 80.3c-2.3 0-4.2.8-5.8 2.3-1.5 1.5-2.3 3.4-2.3 5.5 0 2.2.8 4 2.3 5.5s3.5 2.3 5.8 2.3 4.2-.8 5.8-2.3c1.5-1.5 2.3-3.4 2.3-5.5 0-2.2-.8-4-2.3-5.5-1.6-1.5-3.5-2.3-5.8-2.3M40.1 80.3c-2.3 0-4.2.8-5.8 2.3S32 86 32 88.1c0 2.2.8 4 2.3 5.5s3.5 2.3 5.8 2.3 4.2-.8 5.8-2.3c1.5-1.5 2.3-3.4 2.3-5.5 0-2.2-.8-4-2.3-5.5-1.6-1.5-3.5-2.3-5.8-2.3M79.2 88.1c0 2.2.8 4 2.3 5.5s3.5 2.3 5.8 2.3 4.2-.8 5.8-2.3c1.5-1.5 2.3-3.4 2.3-5.5 0-2.2-.8-4-2.3-5.5s-3.5-2.3-5.8-2.3-4.2.8-5.8 2.3-2.3 3.4-2.3 5.5",
  style: {"fill":"#008ac5"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }